<dx-validation-group #resetPasswordValidationGroup>
    <dx-responsive-box>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>

        <dxi-col></dxi-col>
        <dxi-col></dxi-col>

        <dxi-item>
            <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        placeholder="Username"
                        [(value)]="resetPasswordParameterDto.username"
                        (onEnterKey)="btnResetPasswordClick(null)"
                        class="text-input cc-text-required"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Username is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        ccPreventCopyPaste
                        placeholder="Password"
                        class="text-input cc-text-required"
                        [(value)]="resetPasswordParameterDto.newPassword"
                        [(mode)]="passwordMode"
                        [inputAttr]="{ autocomplete: 'new-password' }"
                        [maxLength]="30"
                        valueChangeEvent="keyup"
                        (onValueChanged)="onPasswordChanged($event)"
                    >
                        <dxi-button
                            *ngIf="passwordMode === 'password'"
                            name="password"
                            location="after"
                            [options]="passwordShowButton"
                        ></dxi-button>
                        <dxi-button
                            *ngIf="passwordMode !== 'password'"
                            name="password"
                            location="after"
                            [options]="passwordHideButton"
                        ></dxi-button>
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="2" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        ccPreventCopyPaste
                        placeholder="Confirm Password"
                        ngClass="text-input cc-text-required"
                        [(mode)]="passwordMode"
                        [inputAttr]="{ autocomplete: 'new-password' }"
                        [maxLength]="30"
                    >
                        <dxi-button
                            *ngIf="passwordMode === 'password'"
                            name="cpassword"
                            location="after"
                            [options]="passwordShowButton"
                        ></dxi-button>
                        <dxi-button
                            *ngIf="passwordMode !== 'password'"
                            name="cpassword"
                            location="after"
                            [options]="passwordHideButton"
                        ></dxi-button>
                        <dx-validator>
                            <dxi-validation-rule
                                type="required"
                                message="Confirm Password is required"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                                type="compare"
                                [comparisonTarget]="passwordComparison"
                                comparisonType="==="
                                message="Password and Confirm Password do not match"
                            ></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="3" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <div>
                        Password should have at least 8 characters with Upper case, lower case, number and special
                        characters ({{ passwordSpecialCharactersAllowable }})
                    </div>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="4" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-progress-bar
                        #passStrengthSuccess
                        [min]="0"
                        [max]="4"
                        [statusFormat]="getPasswordStrengthText"
                    ></dx-progress-bar>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="5" [col]="0" [colspan]="2"></dxi-location>
            <div *dxTemplate class="user-auth-container-input-wrapper align-items-center">
                <re-captcha
                    #reCaptcha
                    [siteKey]="recaptchaSiteKey"
                    (resolved)="onRecaptchaResolved($event)"
                ></re-captcha>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="6" [col]="0"></dxi-location>
            <div
                *dxTemplate
                [ngClass]="{
                    'user-auth-container-btn-wrapper': !isSmallScreen,
                    'user-auth-container-btn-wrapper-small': isSmallScreen
                }"
                class="reset-button-wrapper"
            >
                <div class="reset-button-content">
                    <dx-button
                        #btnReset
                        [icon]="submitIcon"
                        text="Submit"
                        type="default"
                        class="reset-button"
                        [width]="isSmallScreen ? 120 : 130"
                        [height]="30"
                        [disabled]="!recaptchaToken?.length"
                        (onClick)="btnResetPasswordClick($event)"
                    ></dx-button>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="6" [col]="1"></dxi-location>
            <div
                *dxTemplate
                [ngClass]="{
                    'user-auth-container-btn-wrapper': !isSmallScreen,
                    'user-auth-container-btn-wrapper-small': isSmallScreen
                }"
                class="align-items-start"
            >
                <dx-button
                    #btnLogin
                    [icon]="backToLoginIcon"
                    text="Back to Login"
                    type="default"
                    class="login-button"
                    [width]="isSmallScreen ? 110 : 130"
                    [height]="30"
                    (onClick)="btnBackToLogin($event)"
                ></dx-button>
            </div>
        </dxi-item>
    </dx-responsive-box>
</dx-validation-group>

<dx-load-panel
    #loadPanelLogin
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#loginContainer' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
